import config from 'config';

var url = `${process.env.VUE_APP_API_PROTOCOL}://${process.env.VUE_APP_API_HOST}`;
var baseUrl = `${config.protocol}://${config.host}`;

export const API_URL = config.apiPort !== '' ? url + `:${config.apiPort}` : url;
export const BASE_URL = config.port !== '' ? `${baseUrl}:${config.port}` : baseUrl;
export const STATIC_URL = '/public';
